import {Component, Input} from '@angular/core';
import {StoreFilterControlService} from "../product-filter-sidebar/service/store-filter-control.service";
import {FilterControl} from "../product-filter-sidebar/interface/filter-control";
import {UntilDestroy} from "@ngneat/until-destroy";
import {SegmentCategoryControl} from "../product-filter-sidebar/interface/segment-category-control";
import {SubCategoryControls} from "../product-filter-sidebar/interface/sub-category-controls";
import {RangeFilterControl} from "../product-filter-sidebar/interface/range-filter-control";
import {NormalFilterControl} from "../product-filter-sidebar/interface/normal-filter-control";
import {NormalFilterItem} from "../product-filter-sidebar/interface/normal-filter-item";
import {ColorFilterItem} from "../product-filter-sidebar/interface/color-filter-item";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {FabricFilterService} from '../product-filter-sidebar/service/fabric-filter.service';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';

@UntilDestroy()
@Component({
	selector: 'fb-chips-filter',
	templateUrl: './chips-filter.component.html',
	styleUrls: ['./chips-filter.component.scss']
})
export class ChipsFilterComponent {
	@Input() productList: ProductListing[] = [];
	public controls: FilterControl = {} as FilterControl;
	public clearButtonShow: boolean = false;

	constructor(
		private _setControlsObservable: StoreFilterControlService,
		private _filterService: FabricFilterService,
		private _router: Router,
		private _activateRoute: ActivatedRoute,
	) {
	}

	public clearAllFilterOption(): void {
		for (const [key, value] of Object.entries(this.controls)) {

			if (key === 'nestedControls') {

				this.controls[key].forEach((nestedControl: SegmentCategoryControl) => {
					nestedControl.options.forEach((option: SubCategoryControls) => {
						option.activated = false;
					});
					nestedControl.activated = false;
				})
			}


			if (key === 'rangeFilterControls') {

				this.controls[key].forEach((rangeControls: RangeFilterControl): void => {

					rangeControls.values.value1 = 0;
					rangeControls.values.value2 = rangeControls.values.defaultMax;
				})
			}

			if (key === 'normalFilterControls') {

				this.controls[key].forEach((normalControl: NormalFilterControl): void => {

					normalControl.options.forEach((option: NormalFilterItem): void => {
						option.activated = false
					})
				})
			}

			if (key === 'colorFilterControls') {

				this.controls['colorFilterControls'][0].options.forEach((option: ColorFilterItem): void => {
					option.activated = false
				});
			}

			if (key === 'singleFilterControls') {

				this.controls['singleFilterControls'][0].options = false;
			}
		}

		// debugger
		// console.log(this.controls);

		this._filterService.prepareFilterResults(this.controls, this.productList)

		this._router.navigate([], { queryParams: {} });
	}

	public ngOnInit(): void {

		this._setControlsObservable.storedControl.subscribe((controls: FilterControl): void => {
			this.controls = controls;
		});

		this._activateRoute.queryParams.subscribe((params: Params): void => {

			if (Object.keys(params).length != 0) this.clearButtonShow = true;
			else this.clearButtonShow = false;

			if (params['Instock'] && Object.keys(params).length < 2) this.clearButtonShow = false
		});
	}

}
